module.exports = __webpack_public_path__ + "static/aarnet-ec61863853bbcf86f9aaf5b95dcb48df.svg";